import { format, addDays } from 'date-fns';
import { ru } from 'date-fns/locale';

const getDeliveryFormatted = (days = 0, dateFormat = 'EEEEEE, d MMMM') => format(addDays(new Date(), days), dateFormat, { locale: ru });

export default getDeliveryFormatted;
